var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/httpClient.ts
import axios from "axios";
var ApiClient = class {
  constructor(config) {
    this.abortController = new AbortController();
    this.axios = axios.create({
      baseURL: config.baseURL,
      timeout: config.timeout || 1e4,
      headers: config.headers || { "Content-Type": "application/json" }
    });
    this.setupInterceptors();
  }
  configureAuth(config) {
    this.tokenConfig = config;
  }
  setLocaleGetter(getter) {
    this.localeGetter = getter;
  }
  /**
   * Abort all in-flight requests and reset the controller.
   * Call immediately on logout/session-expiry so pending requests
   * do not reach the BFF after the user has signed out.
   */
  cancelAll() {
    this.abortController.abort();
    this.abortController = new AbortController();
  }
  setupInterceptors() {
    this.axios.interceptors.request.use((config) => {
      var _a;
      const lang = (_a = this.localeGetter) == null ? void 0 : _a.call(this);
      if (lang) {
        config.headers["Accept-Language"] = lang;
      }
      config.headers["x-request-id"] = crypto.randomUUID();
      config.signal = this.abortController.signal;
      return config;
    });
    this.axios.interceptors.response.use(
      (response) => response,
      (error) => {
        var _a, _b;
        if (((_a = error.response) == null ? void 0 : _a.status) === 401) {
          (_b = this.tokenConfig) == null ? void 0 : _b.onUnauthorized();
        }
        return Promise.reject(error);
      }
    );
  }
  updateConfig(config) {
    if (config.baseURL) this.axios.defaults.baseURL = config.baseURL;
    if (config.timeout) this.axios.defaults.timeout = config.timeout;
    if (config.headers) {
      this.axios.defaults.headers.common = __spreadValues(__spreadValues({}, this.axios.defaults.headers.common), config.headers);
    }
  }
};
var apiClient = new ApiClient({ baseURL: "" });

// src/handleApiError.ts
import axios2 from "axios";
var handleApiError = (error) => {
  var _a, _b;
  if (axios2.isAxiosError(error)) {
    const data = (_a = error.response) == null ? void 0 : _a.data;
    const result = {
      message: (data == null ? void 0 : data.message) || error.message,
      details: data
    };
    if (((_b = error.response) == null ? void 0 : _b.status) !== void 0) {
      result.code = error.response.status;
    }
    if (typeof (data == null ? void 0 : data.key) === "string" && data.key) {
      result.key = data.key;
    }
    return result;
  }
  if (error instanceof Error) {
    return { message: error.message, code: "UNKNOWN_ERROR" };
  }
  return { message: "An unexpected error occurred", code: "UNKNOWN_ERROR" };
};
export {
  ApiClient,
  apiClient,
  handleApiError
};
//# sourceMappingURL=index.js.map